export default "/assets/images/performance-filter-img-03.webp?385153d5718d7fc1fbe0a9a1e80b33c4";